import axios from 'axios'

import { getHeaderAuthorization } from '../feature/auth/authHeader'

import { apiPath } from './apiVariables'
import { refreshTokenAction } from 'feature/auth/action/refreshTokenAction'
import { store } from 'store'
import { AuthError, authActions } from 'feature/auth/redux/authSlice'

// запросы к API с авторизацией
export const sendRequestWithAuth = axios.create({
  baseURL: apiPath,
})

// тут обрабатываем ошибки
sendRequestWithAuth.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      const { dispatch } = store
      try {
        const refreshed = await refreshTokenAction()

        if (refreshed) {
          // Повторяем исходный запрос — request interceptor подставит новый токен
          return await sendRequestWithAuth(originalRequest)
        } else {
          dispatch(authActions.setAuthInfo({ error: AuthError.tokenExpired }))
        }
      } catch (refreshError) {
        dispatch(authActions.setAuthInfo({ error: AuthError.tokenExpired }))
      }
    }

    return Promise.reject(error)
  },
)

// добавляем заголовки + проверяем наличие access token перед запросом
sendRequestWithAuth.interceptors.request.use(async config => {
  const state = store.getState()
  // Если access token пустой, но refresh token есть — обновляем до запроса
  if (!state.auth.authInfo.accessToken && state.auth.authInfo.refreshToken) {
    await refreshTokenAction()
  }

  const Authorization = getHeaderAuthorization()
  if (!config.headers['Content-Type']) {
    config.headers['Content-Type'] = 'application/json'
  }
  if (Authorization) {
    config.headers.Authorization = Authorization
  }
  return config
})
